import { render, staticRenderFns } from "./MarketingSmsTestModal.vue?vue&type=template&id=0c5604e5&scoped=true"
import script from "./MarketingSmsTestModal.vue?vue&type=script&lang=js"
export * from "./MarketingSmsTestModal.vue?vue&type=script&lang=js"
import style0 from "./MarketingSmsTestModal.vue?vue&type=style&index=0&id=0c5604e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5604e5",
  null
  
)

export default component.exports